import { render, staticRenderFns } from "./shipmentRequestAdd_bak.vue?vue&type=template&id=e0671efe&scoped=true&"
import script from "./shipmentRequestAdd_bak.vue?vue&type=script&lang=js&"
export * from "./shipmentRequestAdd_bak.vue?vue&type=script&lang=js&"
import style0 from "./shipmentRequestAdd_bak.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./shipmentRequestAdd_bak.vue?vue&type=style&index=1&id=e0671efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0671efe",
  null
  
)

export default component.exports